import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { PRIMARY_COLOR } from '../../styles/colors.style'
import { borderRadius, dropShadow } from '../../styles/reusable.style'
import Accordion from './accordion.component'

const StyledAccordionPrimary = styled.div`
	.accordion {
		&-item {
			border: 1px solid #e0e0e0;
			margin-bottom: 0.5rem;
			border-radius: ${borderRadius};
			${dropShadow()} &.open,
            &:hover {
				border: 1px solid ${PRIMARY_COLOR};
				.accordion-item {
					&-header {
						&-title,
						&-icon {
							color: ${PRIMARY_COLOR};
						}
					}
				}
			}

			&-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 1rem 1rem 1rem;
				margin-bottom: 0;

				&-title {
					font-size: 1.8rem;
					padding-right: 1rem;
				}

				&-icon {
					font-weight: 600;
					font-size: 3.2rem;
				}
			}

			&-content {
				margin: 0 3rem;

				& p {
					margin: 0;
				}
			}

			&.open {
				& .accordion-item-header {
					margin-bottom: 0;
				}

				& .accordion-item-content {
					margin: 0 1rem 1rem;
				}
			}
		}
	}
`

/**
 *
 * @param {array} items
 * The items to show as accordion-items. template: { title, content }
 *
 * @param {boolean} arrow
 * Shows the arrow in accordion-item
 *
 * @param {string} identifier
 * Complemente id property on html element
 *
 * @param {boolean} multiple
 * Enable multiple items to be open simultaneously
 *
 * @param {boolean} noAnimated
 * Disbale animate transitions
 */

class AccordionPrimary extends PureComponent {
	render() {
		return (
			<StyledAccordionPrimary>
				<Accordion {...this.props} />
			</StyledAccordionPrimary>
		)
	}
}

AccordionPrimary.propTypes = {
	items: PropTypes.array.isRequired,
	arrow: PropTypes.bool,
	multiple: PropTypes.bool,
	noAnimated: PropTypes.bool,
}

export default AccordionPrimary
